import { formatPercentValue } from "~/utils/functions/formatPercentValue";
import type { ScreenerAsset } from "./types";

// // // //

export function formatAssetReturn(value: number | null): string {
    return value === null ? "—" : `${formatPercentValue(value)}%`;
}

export function getPerformanceSummaryRows(asset: ScreenerAsset) {
    const rows = [
        { label: "1M", value: asset.returns.trailing1Month },
        { label: "3M", value: asset.returns.trailing3Month },
        { label: "YTD", value: asset.returns.yearToDate },
        { label: "1Y", value: asset.returns.trailing1Year },
        {
            label: "Since inception",
            value: asset.returns.sinceInception,
            detail:
                asset.stats.inception === "—"
                    ? undefined
                    : asset.stats.inception,
        },
    ];

    return rows.map((row) => ({
        ...row,
        formattedValue: formatAssetReturn(row.value),
    }));
}
